<template>
  <div>
<!--    <input type="text" className="form-control" placeholder="" v-model="propsValue">-->

<!--    //CC-->
<!--    <button class="btn btn-primary" @click="changeUI('1')">一般</button>-->
<!--    <button class="btn btn-primary" @click="changeUI('2')">外用</button>-->
<!--    <button class="btn btn-primary" @click="changeUI('3')">針劑</button>-->

    <select class="form-control" id="selItems" name="selItems" v-model="uimode">
      <option value="1">一般</option>
      <option value="2">外用</option>
      <option value="3">針劑</option>
    </select>

    <div class="shadow-none p-3 mb-5 bg-light rounded" v-if="uimode==='1'">
      每天<input type="text" class="form-control" id="name" name="name" placeholder="" style="width: 50px;display: inline">次

      <br>
      <label class="radio-inline"><input type="radio" value="" name="">飯前</label>
      <label class="radio-inline"><input type="radio" value="" name="">飯後</label>

      <br>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
        <label class="form-check-label" for="inlineCheckbox1">早</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
        <label class="form-check-label" for="inlineCheckbox2">中</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
        <label class="form-check-label" for="inlineCheckbox2">晚</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
        <label class="form-check-label" for="inlineCheckbox2">睡前</label>
      </div>
      <br>

      <div class="form-group">
        <label class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" checked="">
          <div class="custom-control-label"> 必要時 </div>
        </label>
      </div>
    </div>
    <div class="shadow-none p-3 mb-5 bg-light rounded" v-if="uimode==='2'">
      外用
      <input type="text" class="form-control" id="name" name="name" placeholder="" style="width: 50px"> 天
      <input type="text" class="form-control" id="name" name="name" placeholder="" style="width: 50px"> 次
    </div>
    <div class="shadow-none p-3 mb-5 bg-light rounded"  v-if="uimode==='3'">
      義診當日，由醫師施打
    </div>


  </div>
</template>

<script>
/**

 **/


export default {
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data: function () {
    return {
      id: "",
      dataReady: false,
      propsValue: this.value,
      formData: {
        name: "",
      },
      uimode:"1",
    };
  },
  watch: {
    propsValue(newVal) {
      //this.('input', newVal);
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.propsValue = newVal
    }
  },
  methods: {
    //給予value屬性預設值
    initValue() {
      const isMyObjectEmpty = !Object.keys(this.value).length;

      if (isMyObjectEmpty) {
        let template = {...this.datasDemo};
        this.value = template;
      }
    },
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    changeUI(mode){
      this.uimode=mode
    }
  },
  mounted() {
    // this.initValue()
    //this.loadData()
  },
}
</script>

<style scoped>

</style>
